import styled from 'styled-components';

export const ThreeFour = styled.span`
  display: flex;
  width: 75%;
  height: 100%;
  padding: 12px;
  flex-direction: column;
`;
